export const modalidadeAvaliacaoValueMap: Record<number, string> = {
  1: 'Individual',
  2: 'Dupla / Grupo',
};

export const modalidadeAvaliacaoMap = {
  individual: 1,
  grupo: 2,
};
